const agreementdata_reducer = (state = null, action) => {
	switch(action.type) {

		case 'UPDATEAGREEMENTDATA':
			return action.payload??null;

		default:
			return state;
	}
}

export default agreementdata_reducer;
